import { useEffect } from "react";
import { useState } from "react";
import { Button } from "../UI";
import { AiOutlineFullscreen } from "react-icons/ai";
import { AiOutlineFullscreenExit } from "react-icons/ai";

const CustomStatusBar = ({ api, ...rest }) => {
  const [state, setState] = useState({
    currentPage: 0,
    totalPage: 0,
    count: 0,
    perPage: 20,
  });

  useEffect(() => {
    let interval = setInterval(() => {
      setState((state) => {
        return {
          ...state,
          perPage: api.paginationProxy.pageSize,
          count: api.paginationProxy.masterRowCount,
          currentPage: api.paginationGetCurrentPage() + 1,
          totalPage: api.paginationProxy.totalPages,
        };
      });
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [api.paginationProxy.masterRowCount]);

  const onBtFirst = () => {};

  const onBtNext = () => {
    api.paginationGoToNextPage();
  };
  const onBtLast = () => {};
  const paginationSizeChange = (evt) => {
    api.paginationSetPageSize(Number(evt.target.value));
    api.paginationSetPageSize(Number(evt.target.value));
  };
  const onBtPrevious = () => {
    api.paginationGoToPreviousPage();
  };

  return (
    <div className="ag-status-name-value agcust">
      <div>
        <span className="component">Total Records &nbsp;</span>

        <span className="ag-status-name-value-value">{state?.count}</span>
      </div>

      <div className="pagination_custom">
        <span>
          <Button onClick={onBtFirst} className="pagi">
            <span
              className="ag-icon ag-icon-first"
              unselectable="on"
              role="presentation"
            ></span>
          </Button>
        </span>

        <span>
          <Button onClick={onBtPrevious} className="pagi">
            {" "}
            <span
              class="ag-icon ag-icon-previous"
              unselectable="on"
              role="presentation"
            ></span>
          </Button>{" "}
        </span>
        <span className="lt_pagi">
          Page {state.currentPage} of {state.totalPage}
        </span>
        <span>
          <Button onClick={onBtNext} className="pagi">
            <span
              class="ag-icon ag-icon-next"
              unselectable="on"
              role="presentation"
            ></span>
          </Button>{" "}
        </span>
        <span>
          <Button onClick={onBtLast} className="pagi">
            <span
              class="ag-icon ag-icon-last"
              unselectable="on"
              role="presentation"
            ></span>
          </Button>
        </span>
      </div>
      <div className="page-size-status__bar" id="onChangeref">
        <span>Per Page</span> &nbsp;
        <select
          className="form-control"
          onChange={paginationSizeChange}
          value={state.perPage}
        >
          {" "}
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="50">50</option>
        </select>
        <div className="fullscreen-layout">
          {rest.isFullScreenView ? (
            <AiOutlineFullscreenExit
              size={18}
              onClick={rest.closeFullScreen}
              className="full-screen-view"
            />
          ) : (
            <AiOutlineFullscreen
              size={18}
              onClick={rest.fullScreen}
              className="full-screen-view"
            />
          )}
        </div>
      </div>
    </div>
  );
};
export default CustomStatusBar;
